import { withTimezoneLabel } from "@utils/datetime";

export enum ClientNotificationTableColumns {
  applicationName = "applicationName",
  employee = "employee",
  reason = "reason",
  notificationType = "notificationType",
  createdAt = "createdAt",
  resolvedBy = "resolvedBy",
  resolvedAt = "resolvedAt",
}

export const CLIENT_NOTIFICATION_TABLE_COLUMN_LABELS: Record<
  ClientNotificationTableColumns,
  string
> = {
  [ClientNotificationTableColumns.applicationName]: "Application",
  [ClientNotificationTableColumns.employee]: "Employee",
  [ClientNotificationTableColumns.reason]: "Reason",
  [ClientNotificationTableColumns.notificationType]: "Type",
  [ClientNotificationTableColumns.createdAt]: withTimezoneLabel("Occurred"),
  [ClientNotificationTableColumns.resolvedBy]: "Resolved by",
  [ClientNotificationTableColumns.resolvedAt]: withTimezoneLabel("Resolved at"),
};

export const DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_SETTINGS: Record<
  ClientNotificationTableColumns,
  boolean
> = {
  [ClientNotificationTableColumns.applicationName]: true,
  [ClientNotificationTableColumns.employee]: true,
  [ClientNotificationTableColumns.reason]: true,
  [ClientNotificationTableColumns.notificationType]: false,
  [ClientNotificationTableColumns.createdAt]: true,
  [ClientNotificationTableColumns.resolvedBy]: false,
  [ClientNotificationTableColumns.resolvedAt]: false,
};

export const DEFAULT_HISTORY_CLIENT_NOTIFICATION_TABLE_COLUMN_SETTINGS: Record<
  ClientNotificationTableColumns,
  boolean
> = {
  [ClientNotificationTableColumns.applicationName]: true,
  [ClientNotificationTableColumns.employee]: true,
  [ClientNotificationTableColumns.reason]: true,
  [ClientNotificationTableColumns.notificationType]: false,
  [ClientNotificationTableColumns.createdAt]: true,
  [ClientNotificationTableColumns.resolvedBy]: true,
  [ClientNotificationTableColumns.resolvedAt]: true,
};

export const DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_ORDER: ClientNotificationTableColumns[] =
  [
    ClientNotificationTableColumns.applicationName,
    ClientNotificationTableColumns.employee,
    ClientNotificationTableColumns.reason,
    ClientNotificationTableColumns.notificationType,
    ClientNotificationTableColumns.createdAt,
    ClientNotificationTableColumns.resolvedBy,
    ClientNotificationTableColumns.resolvedAt,
  ];

export const getColumnLabels = (): Record<string, string> =>
  CLIENT_NOTIFICATION_TABLE_COLUMN_LABELS;
export const getDefaultColumnSettings = (): Record<string, boolean> =>
  DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_SETTINGS;
export const getDefaultColumnOrder = (): string[] =>
  DEFAULT_CLIENT_NOTIFICATION_TABLE_COLUMN_ORDER;
